import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import UserService from "../../../../services/user/UserService";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import DataTable from "react-data-table-component";
import { AsyncPaginate } from "react-select-async-paginate";
import { getCurrentDateFormatted } from "../../../../utilities/Utils";
import OffCanvasHasilChecklist from "../offcanvas/OffCanvasHasilChecklist";
import SweetAlert from "react-bootstrap-sweetalert";
import JenisGrade from "../../../../utilities/primer/JenisGrade";

const ModalApproval = ({ showApproval, handleCloseApproval, dataPrimer, dataDisposisi, reloadList, isEdit, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let userService = useMemo(() => new UserService(), [])

    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const year2D = currentYear.toString().slice(-2)

    const columnsEvaluasi = [
        {
            name: 'Nama',
            cell: row => (localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7' ? row['nmEvaluator'] : "***")
        },
        {
            name: 'Catatan Tim Teknis',
            cell: row => row['catatan']
        },
        {
            name: 'Tanggal Evaluasi',
            cell: row => row['tglEvaluasi']
        },
        {
            name: (jenisIzin === 'CPIB' || jenisIzin === 'CBIB' || jenisIzin === 'CPIBK') ? 'Grade' : ((jenisIzin === 'CPOIB' || jenisIzin === 'CDOIB') ? 'Kategori' : 'Tingkat Pengawasan'),
            cell: row => <JenisGrade kodeSert={jenisIzin} kodeGrade={row['kodeGrade']}/>,
        }
    ]

    const columnsRekomendasi = [
        {
            name: 'Nama',
            cell: row => (localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7' ? row['nmRekomendasi'] : "***")
        },
        {
            name: 'Catatan Rekomendasi',
            cell: row => row['catatan']
        },
        {
            name: 'Tanggal Rekomendasi',
            cell: row => row['tglRekom']
        },
        {
            name: (jenisIzin === 'CPIB' || jenisIzin === 'CBIB' || jenisIzin === 'CPIBK') ? 'Grade' : ((jenisIzin === 'CPOIB' || jenisIzin === 'CDOIB') ? 'Kategori' : 'Tingkat Pengawasan'),
            cell: row => <JenisGrade kodeSert={jenisIzin} kodeGrade={row['kdGrade']}/>,
        },
    ]

    const [listEvaluasi, setListEvaluasi] = useState(null)
    const [loading, setLoading] = useState(false)
    const [idInspeksi, setIdInspeksi] = useState(null)
    const [listRekom, setListRekom] = useState(null)
    const [valueTglInspeksi, setValueTglInspeksi] = useState(null)
    const [totalSesuai, setTotalSesuai] = useState('')
    const [totalMinor, setTotalMinor] = useState('')
    const [totalMayor, setTotalMayor] = useState('')
    const [totalKritis, setTotalKritis] = useState('')
    const [totalHasil, setTotalHasil] = useState('')
    const [keterangan, setKeterangan] = useState('')
    const [dataInspeksi, setDataInspeksi] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 9) {
            return
        }
        setLoading(true)
        try {
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndNoSurat(dataPrimer.nomorAju, dataDisposisi.noTugas)
            if (resInspeksi.data !== null) {
                setValueTglInspeksi(resInspeksi.data.tglInspeksi)
                setValueKomoditas(resInspeksi?.data?.komoditas)
                setValuePeruntukan(resInspeksi?.data?.peruntukanProduk)

                const resJenisSert = await pbumkuService.getJenisSertifikasi(jenisIzin, resInspeksi?.data?.jenisSertifikasi)
                setValueJenisSertOpt(resJenisSert?.data)

                const resInspeksiHasil = await pbumkuService.getUmkuHasilInspeksiByAjuAndIdInspeksi(dataPrimer.nomorAju, resInspeksi.data.idInspeksi)
                if (resInspeksiHasil.data !== null) {
                    setTotalSesuai(resInspeksiHasil?.data?.totalSesuai)
                    setTotalMinor(resInspeksiHasil?.data?.totalMinor)
                    setTotalMayor(resInspeksiHasil?.data?.totalMayor)
                    setTotalKritis(resInspeksiHasil?.data?.totalKritis)
                    setTotalHasil(resInspeksiHasil?.data?.totalHasil)
                    setKeterangan(resInspeksiHasil?.data?.keterangan)
                }

                const resInspeksiReviu = await pbumkuService.listUmkuEvaluasiByIdInspeksi(resInspeksi?.data?.idInspeksi)
                setListEvaluasi(resInspeksiReviu?.data?.data)
                setIdInspeksi(resInspeksi?.data?.idInspeksi)
                setDataInspeksi(resInspeksi?.data)

                const resInspeksiRekom = await pbumkuService.listUmkuRekomByIdInspeksi(resInspeksi?.data?.idInspeksi)
                setListRekom(resInspeksiRekom?.data?.data)

                const resInspeksiApprove = await pbumkuService.listUmkuApprovalByIdInspeksi(resInspeksi?.data?.idInspeksi)
                let dtApprove = resInspeksiApprove?.data?.data[0]

                setValueTglApprove(dtApprove?.tglApproval)
                setValueCatatan(dtApprove?.catatan)
                // setValueKomoditas(dtApprove?.komoditas)
                // setValuePeruntukan(dtApprove?.peruntukanProduk)

                // const resJenisSert = await pbumkuService.getJenisSertifikasi(jenisIzin, dtApprove?.jenisSediaanObat)
                // setValueJenisSertOpt(resJenisSert.data)
                const optKesimpulan = await pbumkuService.getKesimpulanById(dtApprove?.idKesimpulan)
                setValueApprovalOpt(optKesimpulan.data)
                const resPegawai = await userService.getPegawaiById(dtApprove?.nipApproval)
                setValuePegawaiOpt(resPegawai.data)

            }
        } catch (error) {

        }
        setLoading(false)
    }, [pbumkuService, dataPrimer, dataDisposisi, userService, jenisIzin])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };

    }, [dataPrimer, fetchAllData])

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => setShowHasilInspeksi()
    const ViewHasilInspeksi = () => {
        setShowHasilInspeksi(true)
    }

    const [valueTglApprove, setValueTglApprove] = useState(getCurrentDateFormatted())
    const [valueCatatan, setValueCatatan] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)

    const [valueApprovalOpt, setValueApprovalOpt] = useState(null)
    const onChangeApproval = e => {
        setValueApprovalOpt(e)
    }

    async function loadOptionApproval(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listKesimpulanByIdDisposisi(9)
        return {
            options: response.data,
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem("kdUnit"), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawai = e => {
        setValuePegawaiOpt(e)
    }
    const handleChangeTglApprove = e => {
        setValueTglApprove(e.target.value)
    }
    const handleChangeCatatan = e => {
        setValueCatatan(e.target.value)
    }

    const [valueJenisSertOpt, setValueJenisSertOpt] = useState(null)
    async function loadOptionJenisSert(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listJenisSertifikasi(jenisIzin, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeJenisSert = e => {
        setValueJenisSertOpt(e)
    }

    const [valueKomoditas, setValueKomoditas] = useState(null)
    const handleChangeKomoditas = e => {
        setValueKomoditas(e.target.value)
    }

    const [valuePeruntukan, setValuePeruntukan] = useState(null)
    const handleChangePeruntukan = e => {
        setValuePeruntukan(e.target.value)
    }

    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleClickConfirmSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const [loadingSimpan, setLoadingSimpan] = useState(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowSimpanSuccess(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseFailed = () => {
        setShowSimpanFailed(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleClickSimpan = async () => {
        setLoadingSimpan(true)
        try {
            const respPerizinan = await pbumkuService.getRefPerizinan(jenisIzin)

            const dtHeader = await pbumkuService.listUmkuHeaderPersetujuan(respPerizinan?.data?.kdIzin, dataPrimer?.nomorAju, null, null, 0, 10, localStorage.getItem('kdUnit'))

            const respNomorSert = await pbumkuService.ambilNomorService('SERT_' + jenisIzin, localStorage.getItem('kdUnit'), currentYear, localStorage.getItem('username'))
            let nomorSertifikat = respNomorSert.data.uraianPusat + '-' + dataInspeksi?.jenisSertifikasi + '-' + dtHeader?.data?.data[0].kodePropinsi + '-' + localStorage.getItem('kdUnit') + '-' + year2D + respNomorSert.data.nomorUrut

            let jsonApproval = {
                idInspeksi: idInspeksi,
                nomorAju: dataPrimer.nomorAju,
                nipApproval: valuePegawaiOpt.nip,
                nmApproval: valuePegawaiOpt.nama,
                tglApproval: valueTglApprove,
                catatan: valueCatatan,
                idKesimpulan: valueApprovalOpt.idKesimpulan,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date(),
                nomorSertifikat: nomorSertifikat,
                jenisSediaanObat: dataInspeksi?.jenisSertifikasi,
                kdGrade: listRekom[0]?.kdGrade
            }
            if (jenisIzin === 'CPIB' || jenisIzin === 'CBIB') {
                jsonApproval = {
                    ...jsonApproval,
                    komoditas: dataInspeksi?.komoditas,
                }
            } else if (jenisIzin === 'CPPIB') {
                jsonApproval = {
                    ...jsonApproval,
                    peruntukanProduk: dataInspeksi?.peruntukanProduk
                }
            }
            // console.log(jsonApproval)

            const resApproval = await pbumkuService.saveUmkuApproval(jsonApproval)
            if (resApproval.data.kode === '200') {
                let dataStatusNext = {
                    nomorAju: dataPrimer.nomorAju,
                    kodeStatus: valueApprovalOpt.kdStatusNext,
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(dataStatusNext)

                let dataHeader = await pbumkuService.getUmkuHeader(dataPrimer.nomorAju)

                let jsonUmkuHeader = {
                    ...dataHeader?.data,
                    kodeStatus: valueApprovalOpt.kdStatusNext
                }
                await pbumkuService.saveUmkuHeader(jsonUmkuHeader)
                setShowConfirmSimpan(false)
                setShowSimpanSuccess(true)
            } else {
                setShowConfirmSimpan(false)
                setShowSimpanFailed(true)
            }

        } catch (error) {
            console.log(error)
            setShowConfirmSimpan(false)
            setShowSimpanFailed(true)
        }
        setLoadingSimpan(false)
    }

    return (
        <>
            <Modal
                show={showApproval}
                onHide={handleCloseApproval}
                centered
                size="xl"
                scrollable
            >
                <Modal.Header><Modal.Title><h5>Persetujuan Penerbitan Sertifikat / Lampiran Teknis {jenisIzin}</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={valueTglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    {
                        (jenisIzin === 'CPIB' || jenisIzin === 'CBIB') &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Komoditas</Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Komoditas" className="form-control-sm" value={valueKomoditas} onChange={handleChangeKomoditas} disabled />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    {
                        jenisIzin === 'CPPIB' &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Peruntukan Produk</Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Peruntukan Produk" className="form-control-sm" value={valuePeruntukan} onChange={handleChangePeruntukan} disabled />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Sertifikasi</Form.Label>
                                    <Col sm="3">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisSert}
                                            value={valueJenisSertOpt}
                                            getOptionValue={(option) => option.jenisSertifikasi}
                                            getOptionLabel={(option) => option.jenisSertifikasi + ' - ' + option.uraianSertifikasi}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisSert}
                                            isDisabled
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" value={totalSesuai} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" value={totalMinor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" value={totalMayor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" value={totalKritis} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" value={totalHasil} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" value={keterangan} disabled />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hasil Inspeksi</Form.Label>
                                    <Col sm="8">
                                        <Button size='sm' variant='outline-info' onClick={() => ViewHasilInspeksi()}><FaSearch />{' '}Lihat Hasil Inspeksi</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Evaluasi Tim Teknis</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <div className="table-responsive border-bottom">
                                {(loading && <Spinner />)}
                                {
                                    listEvaluasi &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsEvaluasi}
                                        data={listEvaluasi}
                                        highlightOnHover
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center" htmlFor="searchNib"><b>Rekomendasi</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-12'>
                            <div className="table-responsive border-bottom">
                                {(loading && <Spinner />)}
                                {
                                    listRekom &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsRekomendasi}
                                        data={listRekom}
                                        highlightOnHover
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Persetujuan</b></Form.Label>
                                    <Col sm="4">
                                        <AsyncPaginate
                                            loadOptions={loadOptionApproval}
                                            value={valueApprovalOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeApproval}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Disetujui</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="Tanggal" className="form-control-sm" value={valueTglApprove} onChange={handleChangeTglApprove} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Pejabat Persetujuan</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPegawai}
                                            value={valuePegawaiOpt}
                                            getOptionValue={(option) => option.nip}
                                            getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangePegawai}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" rows={5} placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={handleChangeCatatan} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {dataPrimer?.kodeStatus === '031' && (localStorage.getItem("role") === "6" || localStorage.getItem("role") === "7" || localStorage.getItem("role") === "1" || localStorage.getItem("role") === "2") && <Button variant="primary" size="sm" onClick={() => handleClickConfirmSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseApproval}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <OffCanvasHasilChecklist showHasilChecklist={showHasilInspeksi} handleCloseHasilChecklist={handleCloseHasilInspeksi} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} jenisIzin={jenisIzin} />
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSimpan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSimpan}
                    reverseButtons
                >
                    {loadingSimpan && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalApproval